<script lang="ts">
  import { _ as t } from "svelte-i18n";
  import type { ActivityDetail } from "../lib/restful";
  import happyIcon from "../assets/images/happy.png";
  import titleBg from "../assets/images/title_backimage.png";
  import lightIcon from "../assets/images/light_icon.png";
  import starIcon from "../assets/images/star.png";
  import emptyIcon from "../assets/images/empty.png";

  let { activityData = null }: { activityData: ActivityDetail | null } =
    $props();

  let myTickets = $derived(activityData?.poolInfo?.myTicketCount ?? 0);
  let tickets = $derived(activityData?.poolInfo?.userTicketDetail ?? []);

  const MAX_VISIBLE = 5;
  let expanded = $state(false);
  let visibleTickets = $derived(
    expanded ? tickets : tickets.slice(0, MAX_VISIBLE),
  );
  let hasMore = $derived(tickets.length > MAX_VISIBLE);

  function formatTime(dateStr?: string): string {
    if (!dateStr) return "--";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }

  /** status: 0-已作废 1-有效(待开奖) 2-已中签 3-未中签 */
  function getStatusInfo(status?: number) {
    if (status === 2)
      return {
        label: $t("lottery_status_won"),
        color: "text-tips-color-success",
        bg: "bg-tips-color-success-opacity-10",
      };
    if (status === 3)
      return {
        label: $t("lottery_status_not_won"),
        color: "text-tips-color-red",
        bg: "bg-tips-color-red-opacity-10",
      };
    return {
      label: $t("lottery_status_pending"),
      color: "text-text-h2",
      bg: "bg-divider-color-1",
    };
  }

  function formatNumber(n: number): string {
    return n.toLocaleString();
  }
</script>

<div
  class="flex flex-col gap-[8px] rounded-[12px] bg-tips-color-appblue px-[16px] py-[24px] mb-[16px] w-full box-border"
>
  <!-- 统计区：背景图 + 左文字右数字 -->
  <div class="relative flex items-center justify-between w-full">
    <img src={titleBg} alt="" class="w-full h-auto" />
    <div class="absolute inset-0 flex items-center justify-between px-[20px]">
      <span class="text-[14px] font-semibold text-white">
        {$t("lottery_my_chances")}
      </span>
      <span
        class="text-[26px] font-bold text-white flex items-center  gap-[4px]"
      >
        {formatNumber(myTickets)}
        <img src={starIcon} alt="" class="w-[20px] h-[20px] mb-1 " />
      </span>
    </div>
  </div>

  <!-- 抽奖记录列表 -->
  {#if tickets.length === 0}
    <div
      class="rounded-[12px] bg-bg-color-1 flex flex-col items-center justify-center h-[227px]"
    >
      <img src={emptyIcon} alt="" class="w-[80px] h-auto mb-[8px]" />
      <span class="text-[14px] text-text-h2">{$t("lottery_empty")}</span>
    </div>
  {:else}
    <div class="rounded-[16px] overflow-hidden bg-bg-color-1 px-[8px] pt-[8px]">
      {#each visibleTickets as ticket}
        <div
          class="flex items-center justify-between p-[8px] border-b border-[#F0F0F0]"
        >
          <div class="flex flex-col gap-[2px] min-w-0 flex-1 mr-[8px]">
            <span class="text-[14px] font-semibold text-text-h1 break-all"
              >{$t("ticket_number_prefix")}{ticket.ticketNumber || ticket.traceId}</span
            >
            <span class="text-[14px] text-text-h2 flex flex-wrap gap-x-[8px]">
              {#if ticket.task}<span class="break-all">{ticket.task}</span>{/if}
              {#if ticket.createTime}<span class="whitespace-nowrap"
                  >{formatTime(ticket.createTime)}</span
                >{/if}
            </span>
          </div>
          <div class="flex flex-col items-end gap-[4px] shrink-0">
            {#if ticket.status === 2}
              <div class="flex flex-col items-end gap-[4px]">
                <span
                  class="flex bg-tips-color-success-opacity-10 items-center gap-[4px] text-[14px] text-tips-color-success font-normal px-[4px] py-[3px] rounded-[4px]"
                >
                  <img src={happyIcon} alt="" class="w-[14px] h-[14px]" />
                  {$t("lottery_status_won")}
                </span>
                {#if ticket.levelName}
                  <span
                    class="text-[12px] text-tips-color-warning bg-tips-color-warning-opacity-10 px-[4px] py-[3px] rounded-[4px]"
                    >{ticket.levelName}</span
                  >
                {/if}
              </div>
            {:else}
              {@const info = getStatusInfo(ticket.status)}
              <span
                class="text-[14px] font-normal px-[4px] py-[3px] rounded-[4px] {info.bg} {info.color}"
              >
                {info.label}
              </span>
            {/if}
          </div>
        </div>
      {/each}
      {#if hasMore}
        <button
          class="flex w-full items-center justify-center gap-[4px] py-[10px] text-[14px] text-text-h3"
          type="button"
          onclick={() => (expanded = !expanded)}
        >
          {expanded ? $t("view_less") : $t("view_more")}
          <svg
            class="w-[14px] h-[14px] transition-transform {expanded
              ? 'rotate-180'
              : ''}"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            ><polyline points="6 9 12 15 18 9"></polyline></svg
          >
        </button>
      {/if}
    </div>
  {/if}
</div>
